<button tabindex="0" matRipple [matRippleDisabled]="disabled" class="button-container" [ngClass]="{ disabled: disabled }">
	<mat-icon class="button-icon">{{ icon }}</mat-icon>
	<span *ngIf="label" class="button-text">{{ label | translate }}</span>
</button>
